import { ComboLayer } from '@sprinklr/stories/widget/WidgetOptions';
import { AnalyticsRequest, Metric, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultPosition } from './PanelTemplatesTheme/constants';
import { Panel } from 'models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import ListeningMetrics from '@sprinklr/stories-services/AnalyticsService/ListeningMetrics';
import {
    ComboLineOptionsImpl,
    ComboColumnOptionsImpl,
} from '../../widgets/ComboChartWidget/options';

export var TemplateComboChart: Panel = {
    id: 'combo-chart',
    name: 'Combo Chart - Legacy',
    description: '',
    tags: ['Standard', 'Combo Chart', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_combo_chart',
        children: [
            {
                type: 'comboChart',
                id: '1',
                name: 'combochart',
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 100,
                        projections: [
                            new Metric({
                                LISTENING: { source: ListeningMetrics.mentions },
                                INBOUND_MESSAGE: {
                                    dimensionName: 'OUTBOUND_COUNT',
                                    heading: 'Outbound Count',
                                },
                                PLATFORM: {
                                    dimensionName: 'PUBLISHED_MESSAGE_COUNT',
                                    heading: 'Volume Of Published Messages',
                                },
                                BENCHMARKING: {
                                    dimensionName: 'PUBLISHED_MESSAGE_COUNT',
                                    heading: 'Volume Of Published Messages',
                                },
                                PAID: { dimensionName: 'spent', heading: 'Spent' },
                                ADVOCACY: {
                                    dimensionName: 'ADVOCACY_ACTIVE_USERS',
                                    heading: 'Total Active Users',
                                },
                                RDB_FIREHOSE: {
                                    dimensionName: 'MENTIONS_COUNT',
                                    heading: 'Mentions',
                                },
                                STORY_MESSAGE: {
                                    dimensionName: 'NEWS_COUNT',
                                    heading: 'News_Mentions',
                                },
                                COMMUNITY: {
                                    dimensionName: 'AUDIENCE_ACTIVITY_COUNT',
                                    heading: 'Activity Count',
                                },
                                SAM: {
                                    dimensionName: 'TOTAL_ENGAGEMENT',
                                    heading: 'Total Engagement',
                                },
                                AUDIENCE_ACTIVITY: {
                                    dimensionName: 'AUDIENCE_ACTIVITY_COUNT',
                                    heading: 'Activity Count',
                                },
                            }),
                            new Metric({
                                LISTENING: { source: ListeningMetrics.distinctUsers },
                                INBOUND_MESSAGE: {
                                    dimensionName: 'INBOUND_COUNT',
                                    heading: 'Inbound Count',
                                },
                                PLATFORM: {
                                    dimensionName: 'TOTAL_ENGAGEMENT',
                                    heading: 'Total Engagement',
                                },
                                BENCHMARKING: {
                                    dimensionName: 'TOTAL_ENGAGEMENT',
                                    heading: 'Total Engagement',
                                },
                                PAID: { dimensionName: 'clicks', heading: 'Clicks' },
                                ADVOCACY: {
                                    dimensionName: 'APPROVED',
                                    heading: 'Total Approved Users',
                                    origReport: 'COMMUNITY_USER',
                                },
                                RDB_FIREHOSE: {
                                    dimensionName: 'DISTINCT_USER_COUNT',
                                    heading: 'Distinct Users',
                                },
                                STORY_MESSAGE: {
                                    dimensionName: 'WEB_SHARES_OVERALL',
                                    heading: 'Web_shares_overall',
                                },
                                COMMUNITY: {
                                    dimensionName: 'TOTAL_USER_COMMENTS',
                                    heading: 'Total User Comments',
                                },
                                SAM: {
                                    dimensionName: 'reportingStats.COMMENTS',
                                    heading: 'reportingStats_COMMENTS',
                                },
                                AUDIENCE_ACTIVITY: {
                                    dimensionName: 'LIKE_ACTIVITY_COUNT',
                                    heading: 'Like Activity Count',
                                },
                            }),
                        ],
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.day },
                                INBOUND_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'snCTm',
                                },
                                PLATFORM: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                BENCHMARKING: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                PAID: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'measurementTime',
                                },
                                ADVOCACY: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'date',
                                },
                                RDB_FIREHOSE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'SN_CREATED_TIME',
                                },
                                STORY_MESSAGE: {
                                    source: ListeningDimensions.day,
                                    dimensionName: 'CREATED_TIME',
                                },
                                COMMUNITY: {
                                    source: ListeningDimensions.activityDate,
                                    dimensionName: 'date',
                                },
                                SAM: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                                AUDIENCE_ACTIVITY: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                            }),
                        ],
                        sorts: [new Sort({ order: 'DESC', projections: 0 })],
                        timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
                    }) as any,
                ],
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                label: {
                    titleText: 'Combo Chart',
                    enabled: true,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                position: DefaultPosition,
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    comboLayers: [
                        {
                            name: '',
                            metrics: [''],
                            displayName: '',
                            chartType: 'comboLine',
                            options: new ComboLineOptionsImpl(),
                        },
                        {
                            name: '',
                            metrics: [''],
                            displayName: '',
                            chartType: 'comboColumn',
                            options: new ComboColumnOptionsImpl(),
                        },
                    ] as ComboLayer[],
                },
            },
        ],
    },
};
